import { render, staticRenderFns } from "./USPage.vue?vue&type=template&id=358cde91&scoped=true"
import script from "./USPage.vue?vue&type=script&lang=js"
export * from "./USPage.vue?vue&type=script&lang=js"
import style0 from "./USPage.vue?vue&type=style&index=0&id=358cde91&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358cde91",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('358cde91')) {
      api.createRecord('358cde91', component.options)
    } else {
      api.reload('358cde91', component.options)
    }
    module.hot.accept("./USPage.vue?vue&type=template&id=358cde91&scoped=true", function () {
      api.rerender('358cde91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/IdentityKYC/components/USPage.vue"
export default component.exports